import axiosClient from "./axiosClient";

const toData = response =>
  response?.data?.data ?? response?.data?.payload ?? response?.data ?? null;

export async function getWebsiteWidgetConfig(options = {}) {
  const response = await axiosClient.get("/integrations/widget", {
    __silentGenericToast: true,
    ...options,
  });
  return toData(response);
}

export async function updateWebsiteWidgetConfig(payload, options = {}) {
  const response = await axiosClient.put("/integrations/widget", payload, {
    __silentGenericToast: true,
    ...options,
  });
  return toData(response);
}

export async function rotateWebsiteWidgetKey(options = {}) {
  const response = await axiosClient.post(
    "/integrations/widget/rotate-key",
    null,
    {
      __silentGenericToast: true,
      ...options,
    }
  );
  return toData(response);
}
